export default {
  'Congratulations!': 'تهانينا!',
  'Application Approved': 'تمت الموافقة على الطلب',
  'Review Rejected': 'تم رفض المراجعة',
  'This Merchant has been onboarded.': 'تم تسجيل هذا التاجر.',
  'Welcome to the Network Family!': 'مرحبًا بك في عائلة نتورك انترناشونال!',
  "You're now fully set up to take payments through Network International.": "أنت الآن جاهز تمامًا لتلقي المدفوعات عبر نتورك انترناشونال.",
  'If you wish to discuss any aspects of your services, please contact us via the details within your welcome kit email.': 'إذا كنت ترغب في مناقشة أي جوانب من خدماتك، يرجى الاتصال بنا عبر التفاصيل الواردة في البريد الإلكتروني لمجموعة الترحيب الخاصة بك.',
  'Application approved!': 'تمت الموافقة على الطلب!',
  'Welcome to the Network family.': 'مرحبًا بك في عائلة نتورك انترناشونال.',
  'We will soon be sending you our welcome kit which will explain the next steps to enable you to start taking payments.': 'سنرسل لك قريبًا مجموعة الترحيب الخاصة بنا والتي ستشرح الخطوات التالية لتمكينك من البدء في تلقي المدفوعات.',
  'Please contact us via our <1>Contact us</1> page if you need any support or have any questions.': 'يرجى الاتصال بنا عبر صفحة <1>اتصل بنا</1> إذا كنت بحاجة إلى أي دعم أو لديك أي أسئلة.',
  'Submit Manual Onboarding': 'إرسال الإعداد اليدوي',
  'Would you like to submit manual onboarding to complete the company application?': 'هل ترغب في تقديم إعداد يدوي لإكمال طلب الشركة؟',
  'Manual onboarding': 'الإعداد اليدوي',
  'Please perform required the manual onboarding steps and confirm the merchant onboarding completion.': 'يرجى تنفيذ خطوات الإعداد اليدوي المطلوبة وتأكيد اكتمال إعداد التاجر.',
  'Confirm completion': 'تأكيد الاكتمال',
  'We are sorry to say that merchant’s application has not been successful this time': 'نأسف لأن طلب التاجر لم ينجح هذه المرة',
  'If you wish to discuss with us, please <1>contact us</1>.': 'إذا كنت ترغب في المناقشة معنا، يرجى <1>الاتصال بنا</1>.',
  'We need more information': 'نحن بحاجة إلى مزيد من المعلومات',
  'Thank you for your application. We have reviewed the information submitted to us and require some clarifications.': 'شكرًا لك على طلبك. لقد قمنا بمراجعة المعلومات المقدمة إلينا ونحتاج إلى بعض التوضيحات.',
  "We request you to select 'Update Application' below and review the following details which you provided": "نطلب منك تحديد 'تحديث الطلب' أدناه ومراجعة التفاصيل التالية التي قدمتها",
  "We request you to select 'Update Application' below and review the following details which you provided:": ":نطلب منك تحديد 'تحديث الطلب' أدناه ومراجعة التفاصيل التالية التي قدمتها",
  'Update application': 'تحديث الطلب',
  'Application amendment history': 'سجل تعديل الطلب',
  Date: 'التاريخ',
  Reason: 'السبب',
  'This  application was declined.': 'تم رفض هذا الطلب.',
  Proceed: 'يتابع',
  'Automated onboarding is in progress': 'الإعداد الآلي قيد التقدم',
  'This application has been successfully approved and the merchant onboarding is in progress. Please wait.':
    'تمت الموافقة على هذا الطلب بنجاح ويجري الآن إعداد التاجر. انتظر من فضلك.',
  'Automated onboarding failed': 'فشل الإعداد التلقائي',
  'This application was failed to be registered in back office systems. Please contact technical support and proceed with manual onboarding.':
    'فشل تسجيل هذا التطبيق في أنظمة المكتب الخلفي. يرجى الاتصال بالدعم الفني ومتابعة الإعداد اليدوي.',
  'This application was failed to be registered in back office systems due to connection error. Retry the registration to proceed.':
    'فشل تسجيل هذا التطبيق في أنظمة المكتب الخلفي بسبب خطأ في الاتصال. أعد محاولة التسجيل للمتابعة.',
  Retry: 'أعد المحاولة',
  'Automated onboarding errors': 'أخطاء التسجيل الآلي',

  // New merchant completion screen
  'You have been approved!': 'لقد تمت الموافقة على طلبك!',
  'Your application number.': 'رقم طلبك.',
  'What Happens Next': 'ماذا يحدث بعد ذلك',
  'Instructions for setting up your selected products have been emailed to you.':
    'تم إرسال تعليمات إعداد المنتجات المختارة إلى بريدك الإلكتروني.',
  'If we need any additional info, we will contact you within 2 business days.':
    'إذا احتججنا إلى معلومات إضافية، سنتواصل معك خلال يومين عمل إن شاء الله.',
  'Have any questions? Feel free to call us at': 'هل لديك أي استفسارات؟ يسعدنا تواصلك عبر',
  'Go to Dashboard': 'الذهاب إلى لوحة التحكم',
  Copied: 'تم النسخ',
  Copy: 'نسخ',
};
